module.exports = __webpack_public_path__ + "img/guide-photo-two.3c291bbb.svg";